import QRCode from "qrcode";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Button from "../../components/Button";
import Gap from "../../components/Gap";
import Loading from "../../components/Loading";
import Navbar from "../../components/Navbar";
import { proses_data } from "../../config/config";
import FETCH_API from "../../config/fetch_api";
import { router } from "../../Constants";
import api from "../../request";
import { showLog } from "../../utils/log";
import { socket } from "../../utils/socket";

function Nobu(params) {
  const location = useLocation();
  const state = location?.state;
  const { addToast } = useToasts();
  let navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState("");
  const [checkPembayaran, setCheckPembayaran] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const userServer = JSON.parse(localStorage.getItem("userServer"));
  // const qrisNobu = localStorage.getItem("qrisNobu")

  async function Cancel() {
    showLog("Nobu Masuk Cancel");
    const transcancel = await api.xendit.paymentTransCancel({
      transactionNo: state.params["data"]["transactionNo"],
      referenceNo: state.params["data"]["referenceNo"],
      amount: state.detailData["grand_total_nett"],
      qrisData: state.params["data"]["qrisData"],
    });
    localStorage.removeItem("idpesanan");
    await Void();
    navigate(`/${router}/lacak-pesanan`, {
      params: transcancel.data,
    });
  }

  async function Void() {
    showLog("Nobu Masuk Void");
    const result = await FETCH_API("void/v2WithoutToken", {
      from_origin: "*",
      userServer: userServer,
      userId: "Admin",
      transCode: "so",
      void_note: "",
      so_id: "",
      transId: state.detailData["id"],
    });
  }

  async function CekStatus() {
    showLog("Nobu Masuk CekStatus");
    let typeDelivery = JSON.parse(localStorage.getItem("typePembayaran"));
    const dataPeyment = state?.[0];
    const user = JSON.parse(localStorage.getItem("login"));
    const orderDate = JSON.parse(localStorage.getItem("orderDate"));
    const id = JSON.parse(localStorage.getItem("idpesanan"));
    const checkPayment = state?.[0]["responseStatus"];
    try {
      let typeDelivery = JSON.parse(localStorage.getItem("typePembayaran"));
      if (checkPayment == "Success") {
        try {
          const transstatus = await FETCH_API("trans-nobu/status", {
            transactionNo: state?.[0]["data"]["transactionNo"],
          });
          // if(transstatus['data']['paymentStatus']== 'Paid')
          if (transstatus["responseStatus"] == "Success") {
            addToast("Pembayaran Berhasil", {
              appearance: "success",
              autoDismiss: true,
            });
            const result = await proses_data();
            if (result.status === "OK") {
              navigate(`${router}/bill`);
              localStorage.removeItem("pesanan");
            } else {
              addToast(result.message, {
                appearance: "error",
                autoDismiss: true,
              });
            }
          } else {
            addToast("Pembayaran belum selesai", {
              appearance: "info",
              autoDismiss: true,
            });
          }
        } catch (error) {
          showLog(`Nobu ${error}`);
          addToast(error, {
            appearance: "info",
            autoDismiss: true,
          });
        }
      }
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(() => {
    showLog("Nobu Masuk useEffect 1");

    const handlePopstate = () => {
      navigate(`/${router}`);
    };

    let checkTimer = null;

    const run = async () => {
      // payment();
      addToast("Pembayaran QR hanya berlaku selama 15 menit", {
        appearance: "warning",
        autoDismiss: true,
      });
      const response = await QRCode.toDataURL(state?.[0]?.data?.qrisData);
      setImageUrl(response);
      checkTimer = setTimeout(() => {
        setCheckPembayaran(true);
      }, 10000);
    };

    run();
    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
      if (checkTimer) clearTimeout(checkTimer);
    };
  }, [addToast, navigate, state]);

  useEffect(() => {
    showLog("Nobu Masuk useEffect 2");
    // GojekStatus()
    // GojekUpdateStatus()

    const handleConnect = () => {
      showLog(`Socket Connected With ID = ${socket.id}`);
    };

    const handleConnectError = (err) => {
      showLog(`Socket Connect Error ${err}`);
    };

    const handlePaymentSuccess = (data) => {
      const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
      const currentTransId = orderDate?.detailData;
      const incomingTransId =
        data?.trans_id ?? data?.transId ?? data?.transID ?? data?.id ?? data?.data?.trans_id;

      if (incomingTransId && currentTransId) {
        if (String(incomingTransId) !== String(currentTransId)) return;
      }

      showLog(
        `[socket:payment-success] incomingTransId=${incomingTransId} currentTransId=${currentTransId}`
      );
      CekStatus();
    };

    socket.on("connect", handleConnect);
    socket.on("connect_error", handleConnectError);
    socket.on("payment-success", handlePaymentSuccess);

    return () => {
      socket.off("connect", handleConnect);
      socket.off("connect_error", handleConnectError);
      socket.off("payment-success", handlePaymentSuccess);
    };
  }, []);

  return (
    <div>
      <Navbar
        urlBack="/order"
        paramsUrlBack={{
          params: state?.[0],
        }}
        type="back"
        label="Pembayaran Nobu"
      />{" "}
      {/* <div onClick={() => Cancel()} style={{ margin: "5px 5px 0", textAlign: 'right' }}>
                <AiOutlineCloseCircle size={30} color="#8B78FF" />
            </div> */}
      <div style={{ paddingTop: "20%" }}>
        <div style={{ margin: "0 20px" }}>
          <div
            style={{ fontSize: 17, textAlign: "center" }}
            className="fonts600"
          >
            Buka aplikasi E-Wallet Anda dan Scan QR Code untuk membayar pesanan
            Anda
          </div>
          <Gap height={30} />
          <div
            style={{ color: "#5451D6", fontSize: 17, textAlign: "center" }}
            className="fonts700"
          >
            Pembayaran dapat dilakukan melalui Nobu
          </div>
        </div>
        <div
          style={{
            justifyContent: "center",
            display: "grid",
            padding: "24px 0",
          }}
        >
          {imageUrl ? (
            <a href={imageUrl} download>
              <img
                style={{ width: 250, height: 250 }}
                src={imageUrl}
                alt="img"
              />
            </a>
          ) : (
            <Loading />
          )}
        </div>
        <div style={{ margin: "0 10%" }}>
          {
            // checkPembayaran &&
            <Button
              onClick={() => {
                CekStatus();
                setLoading(true);
              }}
              color="#fff"
              backgroundColor="#5451D6"
            >
              Cek Pembayaran
            </Button>
          }
        </div>
        {/* <div style={{ margin: '2% 10%' }}>
                {
                        <Button onClick={() => {
                            Cancel()
                            setLoading(false)
                        }}  color="#fff" backgroundColor="red">
                            Cancel Transaksi
                        </Button>
                    }
                </div> */}
      </div>
    </div>
  );
}

export default Nobu;
